<template>
    <div class="companies">
        <router-view />
    </div>
</template>
